import React from 'react';
import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { t } from '../../../i18n';
import { useFilterLabelClassName, useFilterContainerClassName, useFilterInputContainerClassName } from '../../../utils/languageUtils';

interface DateRangeFilterItemProps {
    label: string;
    value?: [string | null, string | null] | null;
    onChange?: (dates: [string | null, string | null] | null) => void;
    className?: string;
    spanClassName?: string;
    allowClear?: boolean;
    required?: boolean;
}

const DateRangeFilterItem: React.FC<DateRangeFilterItemProps> = ({
    label,
    value,
    onChange,
    className,
    spanClassName,
    allowClear = true,
    required = false,
}) => {
    // 如果 allowClear 为 false，禁用清空功能
    // 将字符串转换为 Dayjs 对象以供 DatePicker 使用
    const dayjsValue = value ? [
        value[0] ? dayjs(value[0]) : null,
        value[1] ? dayjs(value[1]) : null
    ] as [Dayjs | null, Dayjs | null] : null;

    // 处理 DatePicker 的变更，将 Dayjs 转换为字符串
    const handleChange = (dates: [Dayjs | null, Dayjs | null] | null, dateStrings: [string, string]) => {
        if (onChange) {
            onChange(dates ? [dateStrings[0] || null, dateStrings[1] || null] : null);
        }
    };

    // 使用统一的样式 Hook，根据语言自动返回合适的样式类名
    // allowWrap=true 允许日期选择器在空间不足时换行
    const containerClassName = useFilterContainerClassName(className, true);
    const labelClassName = useFilterLabelClassName(spanClassName);
    const inputContainerClassName = useFilterInputContainerClassName();

    return (
        <div className={containerClassName}>
            <span className={labelClassName}>
                {required && <span className="text-red-500 mr-1">*</span>}
                {label}
            </span>
            <div className={inputContainerClassName}>
                <DatePicker.RangePicker
                    value={dayjsValue}
                    onChange={handleChange}
                    className="w-full"
                    placeholder={[t('components.input.start'), t('components.input.end')]}
                    format="YYYY/MM/DD"
                    size="middle"
                    style={{ width: '100%' }}
                    allowClear={allowClear}
                />
            </div>
        </div>
    );
};

export default DateRangeFilterItem;
